import React, { useEffect, useRef } from "react";

const ADSENSE_CLIENT = "ca-pub-6656627771615917";

export default function AdSenseBanner({
  slot,
  variant = "top", // "top" | "bottom"
  disabled = false,
}) {
  const insRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (disabled || !slot || pushedRef.current || !insRef.current) return;
    if (typeof window === "undefined") return;

    const pushAd = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushedRef.current = true;
      } catch (err) {
        const msg = String(err?.message || err || "");
        // Évite de casser l’UI en dev/StrictMode ou remount React
        if (/already have ads in them|All ins elements in the DOM/i.test(msg)) {
          return;
        }
        console.warn("[AdSenseBanner] push failed:", msg);
      }
    };

    const t = window.setTimeout(pushAd, 0);
    return () => window.clearTimeout(t);
  }, [slot, disabled]);

  if (disabled || !slot) return null;

  const format =
    variant === "top" ? "horizontal" : "rectangle,horizontal";

  return (
    <aside
      className={`adsense-wrap adsense-wrap--${variant}`}
      aria-label="Publicité"
    >
      <div className="adsense-label">Publicité</div>

      <ins
        ref={insRef}
        className={`adsbygoogle adsense-slot adsense-slot--${variant}`}
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </aside>
  );
}